import styled from 'styled-components';
import NewImageIconSvg from '../assets/newImageIcon.svg';

const NewImageIcon = styled(NewImageIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  fill: ${props => props.fill || props.theme.colors.grey.lightGrey};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default NewImageIcon;
